import { gql } from "@grandvisionhq/graphql";
const voucherPaymentResponse = gql`
  fragment VoucherPaymentResponseFragment on PlaceOrderMutationVoucherPaymentResponse {
    paymentExternalId
    paymentExpiresAt
    paymentExternalReference
    resultType
  }
`;
export {
  voucherPaymentResponse
};
//# sourceMappingURL=voucher-payment-response.js.map
